import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';
import useScreenSize from '../hooks/useScreenSize';

const ModularHeaderImage = ({ data }) => {
  const screenSize = useScreenSize();

  const {
    backgroundColor,
    idContent,
    header,
    image,
    mobileImage,
    noBottomPadding,
    noTopPadding,
  } = data;

  return (
    <div
      className={`${backgroundColor} modular-header-image-container`}
      id={`${idContent}`}
    >
      <div
        className={`modular-global-width modular-heading-secondary modular-text-center  ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        }`}
      >
        <LitStructuredText data={header} />
        <div className="modular-header-image-image">
          <LitImage
            image={screenSize.width > 700 ? image : mobileImage}
            alt="router and details"
          />
        </div>
      </div>
    </div>
  );
};
export default ModularHeaderImage;
export const fragment = graphql`
  fragment ModularHeaderImage on DatoCmsHeaderImage {
    header {
      value
    }
    id
    idContent
    noTopPadding
    noBottomPadding
    image {
      gatsbyImageData
    }
    mobileImage {
      gatsbyImageData
    }
    backgroundColor
    internal {
      type
    }
  }
`;
